// extracted by mini-css-extract-plugin
export default {"HeroText":"styles_HeroText__2-LwJ","HeroText2":"styles_HeroText2__NxI-s","Text":"styles_Text__Obwgc","float_up":"styles_float_up__ErMG5"};